export default __webpack_public_path__ + "static/media/machine.bd9e8bed.png";